// src/stores/sidebar.ts
import { defineStore } from 'pinia';
export const useSidebar = defineStore('sidebar', {
    state: () => ({
        showSidebar: false,
    }),
    actions: {
        toggleSidebar() {
            this.showSidebar = !this.showSidebar;
        },
        openSidebar() {
            this.showSidebar = true;
        },
        closeSidebar() {
            this.showSidebar = false;
        },
    },
});
